<style lang="less" scoped>
    .text-input-area {
        position: relative;
        width: 100%; height: 100%;
        padding-bottom: .44rem;
        background: #fff;
        border-radius: 0.08rem;
        box-sizing: border-box;
        overflow: hidden;
		border: 1px solid #eee;
		padding: .1rem;
		margin-bottom : .2rem;

        .my-textarea {
            width : 100%;
            height: 100%;
            border : none;
            max-width: 100%;
            min-width: 100%;
            //padding: .24rem 0.16rem 0;
            color : #323233;
            //font-size: 0.28rem;
            line-height: .44rem;
            //resize: none;
            &::placeholder {
                color: #9b9b9b;
            }
        }
        .word-count-tip {
            //: absolute;
            //right: 0; bottom: 0;
            color: #9b9b9b;
            font-size: 0.24rem; line-height: .36rem;
            padding: 0 .16rem .08rem;
            text-align: right;
        }
        &.row-control {
            height: auto;
            .my-textarea {
                height: auto;
            }
        }
    }
</style>
<template>
    <div :class="['text-input-area', {'row-control': rows > 0}]">
        <textarea class="my-textarea" :name="name" :placeholder="placeholder" :readonly="readonly" v-model="val" :rows="rows" ref="myTextarea" :style="{height:textHeight}"></textarea>
        <div class="word-count-tip"><span class="cl-danger">{{num}}</span>/{{maxLength}}</div>
    </div>
</template>
<script>
export default {
	name: 'k-textarea',
    model: {
        prop: 'value',
        event: 'on-change',
    },
    props : {
        placeholder: {
            type : String,
            default : '请输入内容'
        },
        maxLength: {
            type: Number,
            default: 200
        },
        value: String,
        rows: {
            type: Number,
            required: false,
        },
        readonly : {
            type: Boolean,
            default: false
        },
        name: {
            type : String,
            default : ''
        }
    },
    data() {
        return {
            val: '',
            num: 0,
            textHeight : '50px'
        }
    },
    
    created() {
        this.val = this.value;
        if (this.row) {

        }
    },
    methods: {
        focus() {
            this.$el.querySelector('textarea').focus();
        },
        autoHeight(){
            let ta = this.$refs.myTextarea;
            this.textHeight = 'auto';
            this.$nextTick(function(){
                this.textHeight = ta.scrollHeight+'px';
            });
        }
    },
    mounted() {
        this.autoHeight()
    },
    watch: {
        val(v){
            if(!v) v = '';
            this.val = v.replace(/\s+/,'').slice(0,this.maxLength);
            this.num = v.length;
            this.autoHeight();
            //this.val = v.replace(/^\s+/,'')
            this.$emit('on-change', this.val)
        },
        value(v){
            this.val = v;
        }
    },
}
</script>